import React from 'react'
import { useField } from 'react-final-form'

interface CustomRadioProps {
  name: string
  label: string
  value: string
  disabled?: boolean
  onChange?: (value: string) => void
}

export const CustomRadio: React.FC<CustomRadioProps> = ({
  name,
  label,
  value,
  disabled,
  onChange
}) => {
  const { input } = useField(name, { type: 'radio', value })

  return (
    <label>
      <input
        {...input}
        type="radio"
        value={value}
        disabled={disabled}
        onChange={e => {
          input.onChange(e)
          onChange?.(e.target.value)
        }}
      />
      {label}
    </label>
  )
}
